import { render, staticRenderFns } from "./FormApplication.vue?vue&type=template&id=6744ac04&scoped=true&"
import script from "./FormApplication.vue?vue&type=script&lang=js&"
export * from "./FormApplication.vue?vue&type=script&lang=js&"
import style0 from "./FormApplication.vue?vue&type=style&index=0&id=6744ac04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744ac04",
  null
  
)

export default component.exports